import { render, staticRenderFns } from "./ProjectIntegrationSocialPosting.vue?vue&type=template&id=756eebfc"
import script from "./ProjectIntegrationSocialPosting.vue?vue&type=script&lang=ts"
export * from "./ProjectIntegrationSocialPosting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports